import { render, staticRenderFns } from "./storeCategoryListComponent.vue?vue&type=template&id=6153d87b&"
import script from "./storeCategoryListComponent.vue?vue&type=script&lang=ts&"
export * from "./storeCategoryListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./storeCategoryListComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports